// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingSpinner_loadingContainer__WwK7S","content":"LoadingSpinner_content__mfyiz","button":"LoadingSpinner_button__TMwtC"};